<template>
  <div class="page signup">

    <!-- 사용자 확인 -->
    <SignUpCheckUser
      v-if="step === 'checkUser'"
      ref="refSignUpCheckUser"
      @clickNext="step = 'smsAuth'"
      @clickBack="goLogin"
    />

    <!-- SMS 인증 -->
    <SignUpSMSAuth
      v-if="step === 'smsAuth'"
      ref="refSignUpSmsAuth"
      :userData="userData"
      @clickNext="step = 'profile'"
      @clickBack="step = 'checkUser'"
    />

    <!-- 프로필 입력 -->
    <SignUpUserForm
      v-if="step === 'profile'"
      ref="refSignUpProfile"
      :userData="userData"
      @clickNext="step = 'completed'"
      @clickBack="step = 'smsAuth'"
      @clickCancel="goLogin"
      @prepareSignUp="onClickSignUp"
    />

    <!-- 회원가입 완료 -->
    <SignUpCompleted
      v-if="step === 'completed'"
      ref="refSignUpCompleted"
      @goLogin="goLogin"
    />

    <!-- 중복된 가입 정보 -->
    <SignUpDuplicated
      v-if="step === 'duplicated'"
      ref="refSignUpDuplicated"
      :userData="userData"
      @goLogin="goLogin"
    />

    <ConfirmDialog ref="refConfirmDialog" @clickOk="clickPopupConfirm" />
  </div>
</template>

<script>
import { mapActions, mapState, mapGetters } from "vuex";
import SignUpCheckUser from "./comp/SignUpCheckUser.vue";
import SignUpSMSAuth from "./comp/SignUpSMSAuth.vue";
import SignUpUserForm from "./comp/SignUpUserForm.vue";
import SignUpCompleted from "./comp/SignUpCompleted.vue";
import SignUpDuplicated from "./comp/SignUpDuplicated.vue";
const modelService = require("@/utils/dataModel.js");
import ConfirmDialog from "@/_zplabZPT/commonComp/dialog/ConfirmDialog.vue";

export default {
  components: {
    SignUpCheckUser,
    SignUpSMSAuth,
    SignUpUserForm,
    SignUpCompleted,
    SignUpDuplicated,
    ConfirmDialog,
  },
  data() {
    return {
      step: "checkUser",
      pwShow: false,
      userData: modelService.userModel(),
      checkedData: null,
    };
  },
  computed: {
    ...mapGetters(["isDev"]),
    ...mapState(["kakaoAccount"]),
  },
  mounted() {
    // this.step = "checkUser"
    // 회원가입 개발시
    if (this.isDev) {
      // this.step = "profile";
      this.userData = modelService.userSampleModel();
    }
  },
  methods: {
    goLogin() {
      this.$router.push({ path: "/login" }).catch(() => {});
    },
    onClickSignUp() {
      // 사용자 회원가입 시 role_type = 'ROLE_USER' 고정
      this.userData.roleType = 'ROLE_USER'

      this.saveDataPreLoginQuery(this.userData).then((res) => {
        if ('errCode' in res.data) {
          if(res.data.errCode === '-100' || res.data.errCode === '-200') {
            this.$helper.showTostMessage("", res.data.message, "error");
            return
          }
        }

        if (res === undefined) return;

        // 회원가입 완료 후 스크롤 상단으로 이동
        window.scrollTo({ top: 0, behavior: 'smooth' });
        this.step = "completed";

      });
    },
    loginAction(e) {
      e.userAgent = navigator.userAgent.toLowerCase();
      this.signIn(e).then((res) => {
        if (res === undefined) return;
        // 리로드
        window.location.href = "/";
      });
    },
    confirmBack() {
      this.$refs.refConfirmDialog.open("정말 뒤로 가시겠습니까?");
    },
    clickPopupConfirm() {
      window.location.href = "/";
    },
    ...mapActions(["signIn", "saveDataPreLoginQuery", "clearKakaoAccount"]),
  },
};
</script>

<style lang="scss">
.signup {
  .bottom-btn {
    margin-top: 40px;
  }

  p.step-sub-title {
    text-align: center;
    margin-bottom: 40px;
  }
}
</style>
